var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((4),function(item,index){return _c('div',{key:index,staticClass:"p_m_b_20"},[_c('el-checkbox',{attrs:{"label":index,"checked":_vm.radio == index,"name":"type"}},[_vm._v("\n\t\t \tB. 樊哙闯帐后，按剑而跽，瞠目啖肉，义责项羽。作者以夸张的语气、漫画的笔触，勾勒了一个霸气逼人的怒目金刚形象。\n\t\t ")])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d81fed8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homes/errors/components/more.vue
// module id = null
// module chunks = 